<script>
  import { onMount, afterUpdate } from 'svelte';
  import LevelIcon from './icons/LevelIcon.svelte';
  import LogMessage from './LogMessage.svelte';
  import Timestamp from './Timestamp.svelte';
  import {rfc3339,fmtOffset} from './util.js';
  import {
    relativeTimestamps,
    localDates,
  } from './settings.js';


  export let n,ts,offset,lvl,msg,sid,mod;
  export let tags = {};
  export let isSelected;
  export let selectLine;
  export let expand;

  let row;
  let lastSelected;

	afterUpdate(() => {
		if (isSelected && !lastSelected) {
      console.debug(`selected ${n}`);
      row.scrollIntoView({block: 'center'});
    }
    lastSelected = isSelected;
  });

  $: msgWidth = $relativeTimestamps ? 'calc(100% - 19rem)' : 'calc(100% - 27rem)';
</script>

<div bind:this={row} class='row' class:isSelected>
  <a class='col' href={`#${n}`} on:click={() => selectLine(n)}>
    <div class='x0'>{n}</div>
  </a>
  <div class='col level'>
    <LevelIcon {lvl}/>
  </div>
  <div class='col {$relativeTimestamps ? "x2" : "x22"}' title='{rfc3339(ts, true, $localDates)}'>
    {#if $relativeTimestamps}
      {fmtOffset(offset)}
    {:else}
      <Timestamp {ts} millis={true} />
    {/if}
  </div>
  <div class='col x1'>{mod}</div>
  <div class='col xmsg' style='width: {msgWidth}; max-width: {msgWidth};'>
    <LogMessage {msg} {expand} />
  </div>
</div>

<style>
  a {
    color: inherit;
    background: #aeb6cb19;
    border-radius: 3px;
    height: 1.8rem;
    display: flex;
    align-items: center;
    transition: all 100ms ease-in-out;
  }
  a:hover {
    background: #dd1c77;
    text-decoration: none;
  }
  .row {
    display: flex;
    border-bottom: 1px solid #cccccc1f;
    padding: 0.25rem 0;
  }
  .isSelected {
    background: rgba(204, 204, 204, 0.08);
  }
  .col {
    margin: 0 0.25rem;
    line-height: 1.77rem;
  }
  .x0 {
    min-width: 2.6rem;
    width: 2.6rem;
    text-align: center;
    color: #aeb6cb;
  }
  .x1 {
    min-width: 2.6rem;
    width: 6rem;
    text-align: left;
  }
  .x2 {
    min-width: 4.5rem;
    width: 4.5rem;
    color: #aeb6cb;
    text-align: right;
    font-family: Iosevka Custom Web;
  }
  .x22 {
    min-width: 2.6rem;
    width: 12.5rem;
    color: #aeb6cb;
    text-align: center;
  }
  .xmsg {
    width: calc(100% - 27rem);
    max-width: calc(100% - 27rem);
    display: flex;
    flex-wrap: wrap;
    word-wrap: anywhere;
  }
  .level {
    min-width: 1.5rem;
    width: 1.5rem;
    height: 1.5rem;
    padding-top: 0.19rem;
  }
  @media (max-width: 640px) {
		.row {
      flex-wrap: wrap;
		}
    .xmsg {
      max-width: none;
      width: 100%;
      width: 100%;
    }
	}
</style>
